<template>
    <div class="login-wrap">


        <!-- <div class="W_reg_header W_logo_wave">
            <router-link to="EntityList">
            <img src="../assets/img/logo.png">
            </router-link>
        </div> -->




        <el-card :class="'box-card '+(windowWidth<=400?'kkphone ':'')+( windowWidth>400&&windowWidth<800?'kkphone2 ':'' )+( windowWidth>400&&windowWidth>=800?'kkweb ':'' )" >
            <div slot="header" class="clearfix">
                <span style="color: #f40;font-weight: bolder;">立刻注册</span>
                <router-link to="Login" style="color: #888888;float: right;font-size: 13px;">已有账号？<span style="color:#0a8cd2">现在登录</span></router-link>

            </div>
            <div>

                <el-form :model="dataForm" :rules="adminRules" ref="dataForm" label-width="0px" >
                    <el-row>
                        <el-col :span="windowWidth>=800?22:24">
                            <div style="padding: 0 10px;">
                                <el-form-item prop="uname">
                                    <el-input placeholder="用户名用于登录，格式：中文数字英文" v-model="dataForm.uname">
                                        <template slot="prepend">&nbsp;&nbsp;用户名&nbsp;&nbsp;</template>
                                    </el-input>
                                </el-form-item>
                                <el-form-item prop="upass">
                                    <el-input type="password" placeholder="请输入密码" v-model="dataForm.upass"
                                              show-password>
                                        <template slot="prepend">&nbsp;&nbsp;新密码&nbsp;&nbsp;</template>
                                    </el-input>
                                </el-form-item>
                                <el-form-item prop="upass2">
                                    <el-input type="password" placeholder="请输入确认密码" v-model="dataForm.upass2"
                                              show-password>
                                        <template slot="prepend">确认密码</template>
                                    </el-input>
                                </el-form-item>
                                <el-form-item prop="email">
                                    <el-input  @input="emailXiala" placeholder="邮箱用于登录找回密码接发邮件等" v-model="dataForm.email">
                                        <template slot="prepend">&nbsp;&nbsp;&nbsp;&nbsp;邮箱&nbsp;&nbsp;&nbsp;</template>
                                    </el-input>
                                    <div class="emailxialac" v-if="showEmailXiala">
                                        <p @click="selemailHandle(t)" v-for="(t,i) in emailLi" :key="i">{{t}}</p>
                                    </div>

                                </el-form-item>
                                <!-- <el-form-item prop="rname">
                                    <el-input placeholder="真实姓名将自动保密，不对外" v-model="dataForm.rname">
                                        <template slot="prepend">真实姓名</template>
                                    </el-input>
                                </el-form-item> -->

                                <el-form-item prop="mobile">
                                    <el-input placeholder="请输入手机" v-model="dataForm.mobile" class="input-with-select">

                                        <el-select slot="prepend" v-model="dataForm.qcountryMobile" style="width: 100px;">
                                            <el-option @click.native="selqcm(t)" v-for="(t,i) in qcountryMobileLi" :key="i" :label="t.name+t.value" :value="t.name+t.value"></el-option>

                                        </el-select>


                                    </el-input>
                                </el-form-item>

                                <el-form-item prop="address">
                                    <el-input placeholder="请输入常住地址" v-model="dataForm.address">
                                        <template slot="prepend">常住地址</template>
                                    </el-input>
                                </el-form-item>

                                <el-form-item prop="code">
                                    <el-input placeholder="请输入验证码" type="number" v-model="dataForm.code">
                                        <template slot="prepend">&nbsp;&nbsp;验证码&nbsp;&nbsp;</template>
                                        <template slot="append">
                                            <img v-if="codeimg!=''" @click="getImgCodeFunc" style="height: 33px;float: left;"
                                                  :src="codeimg">
                                            <span v-else @click="getImgCodeFunc" style="width: 100px;">获取验证码</span>
                                        </template>
                                    </el-input>
                                </el-form-item>

                                <el-form-item><el-checkbox v-model="checked">同意</el-checkbox>   
                                <!-- <span  class="xieyi" @click="editVisible=true">社区规范</span>、  
                                <span @click="editVisible2=true"  class="xieyi">实名认证协议</span>、   -->
                                <span @click="editVisible3=true" class="xieyi">用户协议</span>
                                </el-form-item>


                            </div>
                        </el-col>
                        <!-- <el-col :span="windowWidth>=800?12:24">
                            <div style="padding: 0 10px;color: #888888;">
                                <el-form-item prop="pimg">
                                    <p>上传个人近照</p>
                                    <el-upload
                                            drag
                                            :before-upload="beforeUploadFile"
                                            :show-file-list="false"
                                            :action=FILE_ACTION
                                            :on-success="handleFileSuccess"
                                            accept="image/*"
                                            :data="imgdata"
                                            :multiple="false">

                                        <img v-if="dataForm.pimg!=''" :src="dataForm.pimg" style="max-width: 100%;">
                                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                        <p>支持拖拽上传,{{pimgSize}} M以内</p>
                                    </el-upload>
                                </el-form-item>
                                <el-form-item> 论坛申请表： <p style="color: #666666;text-indent: 2em;">请将申请表格发送到邮箱register@holylightbbs.com  <span  class="xieyi"  @click="dowmloadHandle">表格下载</span></p>
                                </el-form-item>
                                <el-form-item><el-checkbox v-model="checked">同意圣光检索</el-checkbox>   <span  class="xieyi" @click="editVisible=true">社区规范</span>、  <span @click="editVisible2=true"  class="xieyi">实名认证协议</span>、  <span @click="editVisible3=true" class="xieyi">用户协议</span>
                                </el-form-item>



                            </div>
                        </el-col> -->
                        <el-col :span="24">
                            <div class="login-btn" style="padding-left: 20px;margin-bottom: 10px;">
                                <el-button type="primary" @click="submitForm()">立刻注册</el-button>
                                <router-link to="Login"  style="margin-left: 5px; color: #888888;float: center;font-size: 13px;"><el-button type="info" >取消</el-button></router-link>
                            </div>
                        </el-col>
                    </el-row>


                </el-form>
            </div>
        </el-card>
        <div style="height: 20px;"></div>
        <p style="text-align: center;font-size: 10px;color: #666666;">
           如您有任何问题，请联系管理员 Copyright © 2025 圣光检索</p>

        <div style="height: 80px;"></div>


        <!-- 弹出框 -->
        <el-dialog title="圣光检索社区规范"   :close-on-click-modal ="false"  :visible.sync="editVisible" :width="windowWidth<800?'90%':'50%'">
            <div>

                一、圣光检索的用户只依止觉悟者教言，精勤出离，谨言慎行，同修之间应当平等交流，不攀缘不攀比。同时，应严格遵守最新的互联网管理条例，约束身心规范言行，崇尚低调谦卑，理性智慧，践行了脱生死的佛陀本愿。<br>
                <br>
                二、用户自账户注册成功成为圣光检索用户后，应遵守中华人民共和国相关法律法规，并同意对以任何方式使用该登录账号而使用本服务的任何行为及其结果承担全部责任。如用户的行为违反国家法律，用户本人将依法承担全部法律责任；如涉嫌构成犯罪，司法机关将追究用户的刑事责任，本社区将严格按照法律规定的义务及司法机关的要求进行配合。<br>
                同时，如果本社区有理由认为用户的任何行为，包括但不限于用户的任何言论或其他行为违反或可能违反国家法律法规的任何规定，本社区可在任何时候不经任何事先通知终止向用户提供服务。<br>
                <br>
                三、用户同意将不会利用本社区进行任何违法或不正当的活动，包括但不限于下列行为∶<br>
                <br>
                3.1发布或以其他方式传送中华人民共和国法律禁止的信息：　<br>
                (1)	反对宪法所确定的基本原则的内容；<br>
                (2)	危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的内容；<br>
                (3)	损害国家荣誉和利益的内容；<br>
                (4)	煽动民族仇恨、民族歧视、破坏民族团结的内容；<br>
                (5)	破坏国家宗教政策，宣扬邪教和封建迷信的内容；<br>
                (6)	散布谣言，扰乱社会秩序，破坏社会稳定的内容；<br>
                (7)	散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的内容；<br>
                (8)	侮辱或者诽谤他人，侵害他人合法权利的内容；<br>
                (9)	含有虚假、诈骗、有害、胁迫、侵犯他人隐私、骚扰、侵害、中伤、粗俗、猥亵、或其他道德上令人反感的内容；<br>
                (10)	含有中国法律、法规、（部门）规章以及任何具有法律效力之规范所限制或禁止的其他内容；<br>
                (11)	将侵害他人著作权、专利权、商标权、商业秘密或其他专属权利（以下简称“专属权利”）之内容加以发布或以其他方式传送。<br>
                (12)	将依据任何法律、合约或法定关系（例如由于雇佣关系和依据保密合约所得知或揭露之内部资料、专属及机密资料）而知悉但无权传送之任何内容加以发布。<br>
                (13)	将设计目的在于干扰、破坏或限制任何计算机软件、硬件或通讯设备功能之计算机病毒（包括但不限于木马程序（trojan horses））、蠕虫（worms）、定时炸弹、删除蝇（cancelbots）（以下简称“病毒”）或其他计算机代码、档案和程序之任何资料，加以发布、发送或以其他方式传送。<br>
                <br>
                3.2涉足任何破坏真理、违反流通原则的行为，包括但不限于：<br>
                (1)	使用虚假身份信息在本平台注册；<br>
                (2)	否定真理，诽谤侮辱谢安朔老师；<br>
                (3)	在任何场合、地点，以修行或佛法的名义与同修发生金钱往来；<br>
                (4)	在任何场合、地点，以佛弟子身份或以修行内涵，介绍或拉拢同修进行商业活动，或发起任何形式的募捐等集资活动；<br>
                (5)	在任何场合、地点，以修行为内涵，拉拢同修成立或加入组织团体；<br>
                (6)	以截图形式转发本社区的任何信息，包括所有帖子、评论、用户资料等；<br>
                (7)	对本社区任何部分或本社区之内容，进行出售、转售或用于任何其他商业<br>
                (8)	在对外法理法义的分享转发中标注老师名字或头像；<br>
                (9)	以促进修行的名义在微信、QQ等网络平台建群；<br>
                (10)	私自将老师讲法录音以个人意愿进行剪辑、拼接、自立标题做成独立音频传播。<br>
                (11)	宣传其他任何人或机构，或以虚伪不实的方式陈述或谎称与任何人或机构有关。<br>
                所有用户如有以上内容及行为之一，本社区将禁用账号：<br>
                <br>
                3.3涉足任何系列不当内容及行为：<br>
                (1)私下刻意打听师兄工作性质、家庭背景或其他个人隐私信息，做和学法无关的事情；<br>
                (2)在任何场合、地点，以同修的名义，要求对方为其办理私事；<br>
                (3)在本社区发表与修行无关的话题，如时政看法、新闻热点等；<br>
                (4)在任何场合、地点，转帖老师微博以及其他法理文字时，随意拼接或修改原文；<br>
                (5)本社区用户连续四个月不发帖或评论；<br>
                (6)同修之间互相攀缘、膜拜，或互相诋毁，讨论是非。<br>
                (7)跟踪、人肉搜索或以其他方式骚扰他人。<br>
                所有用户如有以上内容及行为之一，本社区将禁言或删除账号：<br>
                <br>
                3.4 以任何方式危害他人的合法权益。<br>
                <br>
                3.5故意或非故意地违反任何适用的当地、国家法律，以及任何具有法律效力的规则。<br>
                <br>
                用户已认可本社区未对用户的使用行为进行全面控制，用户使用任何内容时，包括依据前述内容之正确性、完整性或有效性时，同意将自行加以判断并承担所有风险，而不依赖于本社区。但本社区依其自行之考虑，有权拒绝和删除经由本服务提供而违反本条款的或其他引起本社区反感的任何内容。<br>
                <br>
                四、违规处理<br>
                本社区会视违规性质、严重程度等采取如下一项或几项处理措施：<br>
                <br>
                4.1认定标准<br>
                符合下述任一项的，可认定用户违规：<br>
                (1)	人工排查发现违反本规范情形的。<br>
                (2)	本社区算法系统对一定周期内的数据进行排查后，抓取到异常数据的。<br>
                <br>
                4.2	违规处理措施<br>
                （1）内容处理：删除违规内容。<br>
                （2）账号处理：<br>
                1）禁言。被禁言的账号可浏览帖子，不可发表、评论帖子。禁言时长7天或1个月。<br>
                2）删除。被删除后账号无法登录，无法使用登陆后所有功能。原持有者使用实名信息可再次注册。<br>
                3）禁用。被禁用的账号无法登录，无法使用登录后所有功能。原持有者使用实名信息不可再次注册。<br>
                <br>
                用户若违反社区规范，圣光检索社区将对违规内容和用户做相应处理及通知。<br>
                同时，维护社区环境离不开各位同修的共同努力，我们欢迎同修们在站务区反馈任何可能违规的内容。<br>
                圣光检索社区将根据法律法规和社区管理经验，不断调整和修改社区规范。为维护社区良好氛围，任何有违社区规范或扰乱社区生态秩序的行为，社区有权依据社区规范进行处理。<br>
                <br>
                <br>
            </div>
            <div style="text-align: center;">
                <el-button type="warning" round  @click="editVisible=false">我已阅读</el-button>
            </div>
        </el-dialog>


        <!-- 弹出框 -->
        <el-dialog title="圣光检索实名认证协议"   :close-on-click-modal ="false"  :visible.sync="editVisible2" :width="windowWidth<800?'90%':'50%'">
            <div >
                 用户确认，在开始“圣光检索实名认证”（以下简称“认证”）前，已详细阅读了本协议所有内容。一旦用户开始认证流程，即表示用户充分理解并同意接受本协议的全部内容。


                <br> <br> 一、 关于认证服务的理解与认同
                <br>为了加强圣光检索论坛（以下简称“本社区”）内容的管理，落实内容自审责任，本社区特对所有用户进行实名认证。

                <br><br> 1、认证服务是由本社区提供的一项身份识别服务。除非本协议另有约定，一旦用户签署本协议，相应的身份信息和认证结果将不因任何理由被修改或取消；如果用户的身份信息在完成认证后发生了变更，用户应向本社区提交相关证件，由本社区协助变更用户的认证信息。否则圣光检索有权依照本协议约定对用户的账号进行禁用。

                <br><br>2、用户应保证其提供给本社区的所有资料和信息的真实性、合法性、准确性和有效性。否则，本社区有权拒绝或终止提供本服务，并依照本协议对违规账号进行禁用。
                <br><br>3、本社区有权单方面修改或变更本协议的内容，并通过社区内消息展示变更后的相关文本，无须单独通知用户。本协议进行任何修改或变更后，若用户仍继续使用本社区的服务，即代表用户已阅读、了解并同意接受变更后的协议内容。

                <br>
                <br>二、实名认证程序
                <br>在申请认证前，必须先成为本社区的用户。（或：在注册用户的同时，须完成实名认证。）

                <br>本社区向用户提供的认证服务包括用户手机验证及用户身份信息识别。

                <br><br>1、 手机验证

                <br>（1）中华人民共和国（以下简称“大陆”）个人用户需提供常用手机号，该手机号将用于告知您实名认证的结果信息。

                <br>（2）您提供手机号后，本社区将默认将该手机号与您在本社区的账号进行绑定。

                <br><br>2、身份信息识别

                <br>（1）中华人民共和国（以下简称“大陆”）个人用户需提供证件用于认证：认证当时处于有效期内的身份证、护照等明确标有身份证号的证件之一（需要在线上传手持第二代身份证正面共1张照片）。

                <br>（2）台湾地区、香港地区、澳门地区及海外个人，提供护照信息。

                <br> （3）对于法律规定的无民事行为能力人和限制行为能力人，本社区不向其提供认证服务。

                <br>
                <br>三、身份认证信息管理

                <br> 除注册认证目的外，本社区将不保存用户为完成认证提供的身份信息。
                <br>
                <br>四、 免责
                <br> 发生下列任一情况，本社区无须承担任何责任：

                <br><br>由于您将本社区的账户密码告知他人或未保管好自己的密码或与他人分享账户或任何其他非本社区的过错，导致您的个人资料泄露。
                <br><br>任何由于黑客攻击、计算机病毒入侵、电信部门技术调整导致的影响、因政府管制而造成的暂时性关闭、由于第三方原因（包括不可抗力，例如国际出口的主干线路及国际出口电信提供商一方出现故障、火灾、水灾、雷击、地震、台风、龙卷风、火山爆发、瘟疫和传染病流行、罢工、战争或暴力行为或类似事件等）及其他非因本社区过错而造成的认证信息泄露、丢失、被盗用或被篡改等。
                <br><br>五、 争议处理
                <br> 与本协议有关的任何争议，由双方协商解决。协商不成，应向相关有管辖权的法院提起诉讼。

            </div>
            <div style="text-align: center;">
                <el-button type="warning" round  @click="editVisible2=false">我已阅读</el-button>
            </div>
        </el-dialog>


        <!-- 弹出框 -->
        <el-dialog title="圣光检索服务协议"   :close-on-click-modal ="false"  :visible.sync="editVisible3" :width="windowWidth<800?'90%':'50%'">
            <div>
                 欢迎来到圣光检索

                <br><br>在使用本社区的服务之前，请仔细阅读以下内容，并同意遵守本协议及整体圣光检索社区规则后方可成为圣光检索用户。一旦用户注册成功，则用户与本社区之间自动形成协议关系，用户应当受本协议及所有社区规则的约束。《圣光检索服务协议》《圣光检索社区规范》《圣光检索实名认证协议》及其他已公示或未来即将公示的圣光检索各项通知、公告、声明或其它类似内容将共同构成圣光检索社区规则之不可分割的整体，具有同等的法律效力。如对“本协议”的任何条款表示异议，您可以终止注册或使用圣光检索。若用户删除或我们禁用了用户的账户，本条款的效力终止。

                <br><br>本协议可由本社区随时更新，用户在使用本社区时应当及时关注协议更新，用户同意本社区不承担通知义务。本社区的通知、公告、声明或其它类似内容是本协议及社区规则的一部分。
                <br><br>一、 本社区的服务
                <br><br> 1.1 本社区网络服务的具体内容由本社区根据实际情况提供，例如公共信息板块等。



                <br><br> 1.2 本社区提供的全部网络服务为免费的网络服务。除此之外与相关网络服务有关的设备(如个人电脑、手机等)及所需的费用(如为接入互联网而支付的电话费及上网费、为使用移动网而支付的手机费等)均应由用户自行负担。


                <br><br>二、社区使用规则和义务
                <br><br> 2.1账号守则

                <br><br> 本社区初衷是为修行人提供一个稳定真实的网络交流环境，考虑到用户的实名注册验证，可以更大程度地保证本社区的安全性，符合广大用户利益所需，因此，我们要求每一位用户实名注册账户，且应当承担以下义务：



                <br><br>2.1.1实名进行账户注册和验证。依本社区注册提示填写申请人正确、真实的个人身份信息、注册邮箱、密码、手机号码等信息，并确保今后更新的登录邮箱、头像及手机号码等资料的真实性、有效性和合法性。一个身份证号只允许创建一个账户，且只能供证件本人使用。

                <br><br> 若用户提供任何违法、不道德或本社区认为不适合在圣光检索上展示的资料；或者本社区有理由怀疑用户的行为属于程序操作或恶意操作，本社区有权无须事先通知即可暂停或终止用户使用账号，并拒绝用户于现在和未来使用本服务之全部或任何部分。

                <br><br>

                2.1.2 本社区无须对用户的任何注册与登记资料承担任何责任，包括但不限于鉴别、核实任何注册与登记资料的真实性、正确性、完整性、适用性，及是否为最新资料的责任。

                <br><br>

                2.1.3用户账号的所有权归本社区，用户仅享有使用权。未经本社区许可，任何人不得赠与、借用、租用、转让或售卖本社区账号，或者以其他方式许可非初始申请注册人使用本社区账号。



                <br><br> 2.1.4用户有义务保证密码和账号的安全，应对所有使用用户的账号的行为负完全责任。用户应同意：

                <br> 1）当用户的账号遭到未获授权的使用，或者发生其它任何安全问题时，用户将立即通知本社区；

                <br> 2）如果用户未保管好自己的账号和密码，因此而产生的任何损失或损害，本社区不承担任何责任；

                <br> 3）用户要对使用账号的所有行为给用户本人、本社区或第三方造成的损害负全责，包括用户本人未保管好自己的账号或密码的情形。

                <br><br>  本社区无须对任何用户的密码和账号的安全承担任何责任。



                <br><br>2.2 用户发布内容规范

                <br>  此部分规定，请参照《圣光检索社区规范》执行。



                <br><br> 2.3 用户专属权利：

                <br>  2.3.1 本社区尊重他人合法权益（包括知识产权、名誉权、商誉权等），呼吁用户也尊重他人合法权益。

                <br>  2.3.2 如果用户违反法律法规的禁止性规定、对他人的合法权益或公众利益造成侵害，本社区将依国家法律法规，在适当的情形下，依本协议或相关规定，进行“删除特定内容”“终止用户对账户的使用”等处理。

                <br>2.3.3 若用户认为自己的合法权益遭到侵害，请向本社区邮箱（<a href="mailto:service@holylightbbs.com">service@holylightbbs.com</a>）提交投诉，圣光检索将依法进行处理。

                <br><br>

                <br> 三、内容版权声明和社区免责条款

                <br><br> 3.1 根据有关法律法规，本社区在此郑重提醒用户：任何经由本社区而发布、上传的文字、音乐、图片、图形、视频或其他资料（以下简称“内容”），无论是公开还是非公开传送，均由内容提供者承担责任。用户应承诺其发表或上传到本网站的任何内容不具有任何侵权性质。用户应承担任何有可能因为其上传内容引发或导致的侵权责任。

                但本社区有权依法停止传输任何前述内容并采取相应行动，包括但不限于暂停用户使用本社区的全部或部分功能，保存有关记录，并向有关机关报告等。

                <br><br>

                3.2 若注册并成为用户，将被视为自动同意放弃用户发表内容的相关知识产权。用户因此不享有对所发表内容的任何专有独占权力，社区可视需要将其转载、引用或收集整理成册。

                <br><br>

                3.3 本社区所有内容仅代表作者自己的立场和观点，与本社区无关，本社区不承担任何内容审查责任。如涉及相关纠纷或责任，由作者本人承担一切法律责任。

                <br><br>

                3.4 用户了解并同意，本社区之服务、产品与资料仅依其当前所呈现的状况提供，而且本社区明确地表示拒绝对于“服务”“资料”“产品”等给予任何明示或暗示之担保或保证，包括但不限于，为商业使用、适合于特定目的或未侵害他人权利之担保或保证等。本社区对于因“服务”“资料”“产品”等所产生之任何直接、间接、附带的或因此而导致之衍生性损失概不负责。本社区对于任何用户信息或个性化设定之时效、删除、传递错误、未予储存或其他任何问题，均不承担任何责任。



                <br><br> 3.5 用户明确了解并同意，基于以下原因而造成的，包括但不限于经济、信誉、数据损失或其他无形损失，本社区不承担任何直接、间接、附带、特别、衍生性或惩罚性赔偿责任：

                <br>  1）本社区之使用或无法使用；

                <br>  2）用户的传输或数据遭到未获授权的存取或改变；
                <br>  3）任何第三方在本服务中所作之声明或行为；

                <br> 4）第三方以任何方式发布或投递欺诈性信息，或诱导用户受到经济损失；

                <br> 5）与本服务相关的其他事宜，但本使用协议有明确规定的除外。

                <br>

                3.5 用户同意本社区有权制订关于使用本服务的一般措施及限制，包括但不限于本服务将保留所发布内容或其它发布内容之最长期间。通过本社区发布或传送之任何信息、通讯资料和其它内容，如被删除或未予储存，用户同意本社区无须承担任何责任。用户也同意，本社区有权依其自行之考虑，不论通知与否，可随时变更一般措施及限制。

                <br><br>

                四、本社区的隐私保护责任及承诺

                <br><br> 保护用户个人信息安全既是法律要求，也是本社区恪尽职守的一项基本原则。本社区将根据中国法律、本协议的规定处理用户的个人信息。我们向您承诺：用户在注册时提供给本社区的个人真实信息仅为注册所用。



                <br><br>4.1本社区不对外公开或向第三方提供任何用户的注册资料，但下列情况除外：

                <br> (1)事先获得用户的明确授权；

                <br> (2)根据有关的法律法规要求；
                <br>  (3)按照相关政府主管部门的要求；

                <br> (4)为维护社会公众的利益。

                <br><br>

                4.2 出于管理需要，本社区可能会与独立第三方合作，共同向用户提供相关的网络服务，在此情况下，如该第三方同意承担与本社区同等的保护用户隐私的责任，则本社区有权将用户的注册资料等提供给该第三方。

                <br><br>

                五、服务的中断、终止以及免责声明

                <br><br>5.1 用户明确同意其使用本社区网络服务所存在的风险及一切后果将完全由用户本人承担，本社区对此不承担任何责任。



                <br><br> 5.2 鉴于网络服务的特殊性（包括但不限于服务器的稳定性问题、恶意的网络攻击等行为或本社区无法控制的情形），用户同意本社区有权随时中断或终止部分或全部的服务。本社区无法保证网络服务一定能满足用户的要求，也不保证网络服务的及时性、安全性、准确性。



                <br><br> 5.3 用户理解本社区需要定期或不定期对提供服务的平台或相关设备进行维护、升级或因其他原因而暂停部分或全部服务，如因此类情况而造成服务在合理时间内的中断，本社区无须为此承担任何责任。对于因不可抗力或本社区不能控制的原因造成的网络服务中断或其它缺陷，本社区不承担任何责任，但将尽力减少因此而给用户造成的损失和影响。



                <br><br>  5.4如发生以下任何一种情形，本社区有权随时中断或终止向用户提供本协议项下的服务而无须对用户或任何第三方承担责任：

                <br> 1）用户提供个人资料不真实；

                <br> 2）用户违反法律、政策或违反本使用协议。

                <br><br>
                5.5 用户同意本社区基于其自行之考虑，因任何理由，包含但不限于——缺乏使用，或本社区认为用户已经违反本使用协议，终止用户的账号或本服务之使用（或服务之任何部分），并将用户在本服务内任何内容加以移除并删除。用户同意依本使用协议任何规定提供之服务，无须进行事先通知即可中断或终止。用户承认并同意，本社区可立即关闭或注销用户的账号及删除用户账号中所有相关信息及文件，及/或禁止继续使用前述文件或本服务。此外，用户同意若本服务之使用被中断、终止或用户的账号及相关信息和文件被关闭、注销，本社区对用户或任何第三人均不承担任何责任。



                <br><br>六、协议修改

                <br><br> 6.1社区的服务和功能会持续提升完善，因此，本协议、社区规则可由本社区随时更新，以准确匹配我们的服务。用户在使用本社区时应当及时关注协议更新，用户同意本社区不承担通知义务。

                <br><br> 6.2 本社区有权于任何时间暂时或永久修改或终止本服务(或其任何部分)，而无论其通知与否，本社区对用户和任何第三人均无需承担任何责任。



                <br><br>  七、附则

                <br> <br>7.1 本社区公布的《圣光检索服务协议》、《圣光检索社区规范》、《圣光检索实名认证协议》及其他已公示或未来即将公示的圣光检索各项通知、公告、声明或其它类似内容将共同构成圣光检索社区规则之不可分割的整体，具有同等的法律效力，共同规范用户对于本服务之使用行为。在用户使用相关服务、使用第三方提供的内容或软件时，亦应遵从所适用之附加条款及条件。

                <br><br> 7.2本协议的订立、执行和解释及争议的解决均应适用中华人民共和国法律。

                <br><br> 7.3 如本协议中的任何条款无论因何种原因完全或部分无效或不具有执行力，本协议的其余条款仍应有效并且有约束力。

                <br> <br>7.4 本协议解释权及修订权归本社区所有。

            </div>
            <div style="text-align: center;">
                <el-button type="warning" round  @click="editVisible3=false">我已阅读</el-button>
            </div>
        </el-dialog>

         <!-- 弹出框 -->
        <el-dialog title="服务协议"   :close-on-click-modal ="false"  :visible.sync="editVisible4" :width="windowWidth<800?'90%':'50%'">
            <div>
                 欢迎来到收集网站

                <br><br>在使用本社区的服务之前，请仔细阅读以下内容，并同意遵守本协议及整体圣光检索社区规则后方可成为圣光检索用户。一旦用户注册成功，则用户与本社区之间自动形成协议关系，用户应当受本协议及所有社区规则的约束。《圣光检索服务协议》《圣光检索社区规范》《圣光检索实名认证协议》及其他已公示或未来即将公示的圣光检索各项通知、公告、声明或其它类似内容将共同构成圣光检索社区规则之不可分割的整体，具有同等的法律效力。如对“本协议”的任何条款表示异议，您可以终止注册或使用圣光检索。若用户删除或我们禁用了用户的账户，本条款的效力终止。

                <br><br>本协议可由本社区随时更新，用户在使用本社区时应当及时关注协议更新，用户同意本社区不承担通知义务。本社区的通知、公告、声明或其它类似内容是本协议及社区规则的一部分。
                <br><br>一、 本社区的服务
                <br><br> 1.1 本社区网络服务的具体内容由本社区根据实际情况提供，例如公共信息板块等。



                <br><br> 1.2 本社区提供的全部网络服务为免费的网络服务。除此之外与相关网络服务有关的设备(如个人电脑、手机等)及所需的费用(如为接入互联网而支付的电话费及上网费、为使用移动网而支付的手机费等)均应由用户自行负担。


                <br><br>二、社区使用规则和义务
                <br><br> 2.1账号守则

                <br><br> 本社区初衷是为修行人提供一个稳定真实的网络交流环境，考虑到用户的实名注册验证，可以更大程度地保证本社区的安全性，符合广大用户利益所需，因此，我们要求每一位用户实名注册账户，且应当承担以下义务：



                <br><br>2.1.1实名进行账户注册和验证。依本社区注册提示填写申请人正确、真实的个人身份信息、注册邮箱、密码、手机号码等信息，并确保今后更新的登录邮箱、头像及手机号码等资料的真实性、有效性和合法性。一个身份证号只允许创建一个账户，且只能供证件本人使用。

                <br><br> 若用户提供任何违法、不道德或本社区认为不适合在圣光检索上展示的资料；或者本社区有理由怀疑用户的行为属于程序操作或恶意操作，本社区有权无须事先通知即可暂停或终止用户使用账号，并拒绝用户于现在和未来使用本服务之全部或任何部分。

                <br><br>

                2.1.2 本社区无须对用户的任何注册与登记资料承担任何责任，包括但不限于鉴别、核实任何注册与登记资料的真实性、正确性、完整性、适用性，及是否为最新资料的责任。

                <br><br>

                2.1.3用户账号的所有权归本社区，用户仅享有使用权。未经本社区许可，任何人不得赠与、借用、租用、转让或售卖本社区账号，或者以其他方式许可非初始申请注册人使用本社区账号。



                <br><br> 2.1.4用户有义务保证密码和账号的安全，应对所有使用用户的账号的行为负完全责任。用户应同意：

                <br> 1）当用户的账号遭到未获授权的使用，或者发生其它任何安全问题时，用户将立即通知本社区；

                <br> 2）如果用户未保管好自己的账号和密码，因此而产生的任何损失或损害，本社区不承担任何责任；

                <br> 3）用户要对使用账号的所有行为给用户本人、本社区或第三方造成的损害负全责，包括用户本人未保管好自己的账号或密码的情形。

                <br><br>  本社区无须对任何用户的密码和账号的安全承担任何责任。



                <br><br>2.2 用户发布内容规范

                <br>  此部分规定，请参照《圣光检索社区规范》执行。



                <br><br> 2.3 用户专属权利：

                <br>  2.3.1 本社区尊重他人合法权益（包括知识产权、名誉权、商誉权等），呼吁用户也尊重他人合法权益。

                <br>  2.3.2 如果用户违反法律法规的禁止性规定、对他人的合法权益或公众利益造成侵害，本社区将依国家法律法规，在适当的情形下，依本协议或相关规定，进行“删除特定内容”“终止用户对账户的使用”等处理。

                <br>2.3.3 若用户认为自己的合法权益遭到侵害，请向本社区邮箱（<a href="mailto:service@holylightbbs.com">service@holylightbbs.com</a>）提交投诉，圣光检索将依法进行处理。

                <br><br>

                <br> 三、内容版权声明和社区免责条款

                <br><br> 3.1 根据有关法律法规，本社区在此郑重提醒用户：任何经由本社区而发布、上传的文字、音乐、图片、图形、视频或其他资料（以下简称“内容”），无论是公开还是非公开传送，均由内容提供者承担责任。用户应承诺其发表或上传到本网站的任何内容不具有任何侵权性质。用户应承担任何有可能因为其上传内容引发或导致的侵权责任。

                但本社区有权依法停止传输任何前述内容并采取相应行动，包括但不限于暂停用户使用本社区的全部或部分功能，保存有关记录，并向有关机关报告等。

                <br><br>

                3.2 若注册并成为用户，将被视为自动同意放弃用户发表内容的相关知识产权。用户因此不享有对所发表内容的任何专有独占权力，社区可视需要将其转载、引用或收集整理成册。

                <br><br>

                3.3 本社区所有内容仅代表作者自己的立场和观点，与本社区无关，本社区不承担任何内容审查责任。如涉及相关纠纷或责任，由作者本人承担一切法律责任。

                <br><br>

                3.4 用户了解并同意，本社区之服务、产品与资料仅依其当前所呈现的状况提供，而且本社区明确地表示拒绝对于“服务”“资料”“产品”等给予任何明示或暗示之担保或保证，包括但不限于，为商业使用、适合于特定目的或未侵害他人权利之担保或保证等。本社区对于因“服务”“资料”“产品”等所产生之任何直接、间接、附带的或因此而导致之衍生性损失概不负责。本社区对于任何用户信息或个性化设定之时效、删除、传递错误、未予储存或其他任何问题，均不承担任何责任。



                <br><br> 3.5 用户明确了解并同意，基于以下原因而造成的，包括但不限于经济、信誉、数据损失或其他无形损失，本社区不承担任何直接、间接、附带、特别、衍生性或惩罚性赔偿责任：

                <br>  1）本社区之使用或无法使用；

                <br>  2）用户的传输或数据遭到未获授权的存取或改变；
                <br>  3）任何第三方在本服务中所作之声明或行为；

                <br> 4）第三方以任何方式发布或投递欺诈性信息，或诱导用户受到经济损失；

                <br> 5）与本服务相关的其他事宜，但本使用协议有明确规定的除外。

                <br>

                3.5 用户同意本社区有权制订关于使用本服务的一般措施及限制，包括但不限于本服务将保留所发布内容或其它发布内容之最长期间。通过本社区发布或传送之任何信息、通讯资料和其它内容，如被删除或未予储存，用户同意本社区无须承担任何责任。用户也同意，本社区有权依其自行之考虑，不论通知与否，可随时变更一般措施及限制。

                <br><br>

                四、本社区的隐私保护责任及承诺

                <br><br> 保护用户个人信息安全既是法律要求，也是本社区恪尽职守的一项基本原则。本社区将根据中国法律、本协议的规定处理用户的个人信息。我们向您承诺：用户在注册时提供给本社区的个人真实信息仅为注册所用。



                <br><br>4.1本社区不对外公开或向第三方提供任何用户的注册资料，但下列情况除外：

                <br> (1)事先获得用户的明确授权；

                <br> (2)根据有关的法律法规要求；
                <br>  (3)按照相关政府主管部门的要求；

                <br> (4)为维护社会公众的利益。

                <br><br>

                4.2 出于管理需要，本社区可能会与独立第三方合作，共同向用户提供相关的网络服务，在此情况下，如该第三方同意承担与本社区同等的保护用户隐私的责任，则本社区有权将用户的注册资料等提供给该第三方。

                <br><br>

                五、服务的中断、终止以及免责声明

                <br><br>5.1 用户明确同意其使用本社区网络服务所存在的风险及一切后果将完全由用户本人承担，本社区对此不承担任何责任。



                <br><br> 5.2 鉴于网络服务的特殊性（包括但不限于服务器的稳定性问题、恶意的网络攻击等行为或本社区无法控制的情形），用户同意本社区有权随时中断或终止部分或全部的服务。本社区无法保证网络服务一定能满足用户的要求，也不保证网络服务的及时性、安全性、准确性。



                <br><br> 5.3 用户理解本社区需要定期或不定期对提供服务的平台或相关设备进行维护、升级或因其他原因而暂停部分或全部服务，如因此类情况而造成服务在合理时间内的中断，本社区无须为此承担任何责任。对于因不可抗力或本社区不能控制的原因造成的网络服务中断或其它缺陷，本社区不承担任何责任，但将尽力减少因此而给用户造成的损失和影响。



                <br><br>  5.4如发生以下任何一种情形，本社区有权随时中断或终止向用户提供本协议项下的服务而无须对用户或任何第三方承担责任：

                <br> 1）用户提供个人资料不真实；

                <br> 2）用户违反法律、政策或违反本使用协议。

                <br><br>
                5.5 用户同意本社区基于其自行之考虑，因任何理由，包含但不限于——缺乏使用，或本社区认为用户已经违反本使用协议，终止用户的账号或本服务之使用（或服务之任何部分），并将用户在本服务内任何内容加以移除并删除。用户同意依本使用协议任何规定提供之服务，无须进行事先通知即可中断或终止。用户承认并同意，本社区可立即关闭或注销用户的账号及删除用户账号中所有相关信息及文件，及/或禁止继续使用前述文件或本服务。此外，用户同意若本服务之使用被中断、终止或用户的账号及相关信息和文件被关闭、注销，本社区对用户或任何第三人均不承担任何责任。



                <br><br>六、协议修改

                <br><br> 6.1社区的服务和功能会持续提升完善，因此，本协议、社区规则可由本社区随时更新，以准确匹配我们的服务。用户在使用本社区时应当及时关注协议更新，用户同意本社区不承担通知义务。

                <br><br> 6.2 本社区有权于任何时间暂时或永久修改或终止本服务(或其任何部分)，而无论其通知与否，本社区对用户和任何第三人均无需承担任何责任。



                <br><br>  七、附则

                <br> <br>7.1 本社区公布的《圣光检索服务协议》、《圣光检索社区规范》、《圣光检索实名认证协议》及其他已公示或未来即将公示的圣光检索各项通知、公告、声明或其它类似内容将共同构成圣光检索社区规则之不可分割的整体，具有同等的法律效力，共同规范用户对于本服务之使用行为。在用户使用相关服务、使用第三方提供的内容或软件时，亦应遵从所适用之附加条款及条件。

                <br><br> 7.2本协议的订立、执行和解释及争议的解决均应适用中华人民共和国法律。

                <br><br> 7.3 如本协议中的任何条款无论因何种原因完全或部分无效或不具有执行力，本协议的其余条款仍应有效并且有约束力。

                <br> <br>7.4 本协议解释权及修订权归本社区所有。

            </div>
            <div style="text-align: center;">
                <el-button type="warning" round  @click="editVisible4=false">我已阅读</el-button>
            </div>
        </el-dialog>

    </div>


</template>

<script>
    import {getImgCode,checkOne,reg} from '../api/index';
    import {getSessionid, qcountryMobileLi, pimgSize, isWeb, getWindowWidth} from '../api/common';
    import { validateUname,validateUpass,validateEmail ,validateMobile,validateRealname} from '../api/validator';

    export default {
        name: "Reg",
        data() {
            const checkExistUname = (rule, str, callback) => {
                if (str === null || typeof str === "undefined" || str === "") {
                    callback("不能为空");
                } else {
                    checkOne({name:'uname',value:str}).then((res) => {
                        if (res.data.status == 1) {
                            callback();
                        } else {
                            callback(res.data.msg);
                        }
                    })

                }
            };
            const checkExistEmail = (rule, str, callback) => {
                if (str === null || typeof str === "undefined" || str === "") {
                    callback("不能为空");
                } else {
                    checkOne({name:'email',value:str}).then((res) => {
                        if (res.data.status == 1) {
                            callback();
                        } else {
                            callback(res.data.msg);
                        }
                    })

                }
            };
            const checkExistMobile = (rule, str, callback) => {
                if (str === null || typeof str === "undefined" || str === "") {
                    callback("不能为空");
                } else {
                    checkOne({name:'mobile',value:str}).then((res) => {
                        if (res.data.status == 1) {
                            callback();
                        } else {
                            callback(res.data.msg);
                        }
                    })

                }
            };

            const confirmPassword = (rule, str, callback) => {
                if (str === null || typeof str === "undefined" || str === "") {
                    callback("请输入确认密码");
                } else if (str !== this.dataForm.upass) {
                    callback('两次输入密码不一致!');
                } else {
                    callback();
                }
            };

            return {

                windowWidth:0,

                pimgSize:0,
                FILE_ACTION:'',
                download_applydoc:'',

                editVisible:false,
                editVisible2:false,
                editVisible3:false,
                editVisible4:false,

                codeimg:'',
                sessionid:'',

                emailLi:[],
                showEmailXiala:false,

                qcountryMobileLi: [],

                imgdata:{},

                checked:false,



                dataForm: {
                    uname: "",
                    upass: "",
                    upass2: "",
                    email: "",
                    rname: "",
                    mobile: "",
                    qcountryMobile: "" ,
                    countryMobile: "" ,
                    quhaoMobile: "" ,
                    address: "" ,
                    code: "" ,
                    pimg: "" ,
                },
                adminRules: {
                    uname: [   { required: true, message: "请输入用户名", trigger: "blur"},
                        {validator: validateUname, trigger: "blur"},
                        {validator: checkExistUname, trigger: "blur"}],
                    upass: [   {required: true, message: "请输入密码", trigger: "blur"},
                        {validator: validateUpass, trigger: "blur"},  ],
                    upass2: [   {required: true, message: "请输入确认密码", trigger: "blur"},
                        {validator: confirmPassword, trigger: "blur"},  ],
                    email: [   {required: true, message: "请输入邮箱", trigger: "blur"},
                        {validator: validateEmail, trigger: "blur"},
                        {validator: checkExistEmail, trigger: "blur"},   ],
                    rname: [   {required: true, message: "请输入姓名", trigger: "blur"},
                        {validator: validateRealname, trigger: "blur"}  ],
                    mobile: [   {required: true, message: "请输入手机号", trigger: "blur"},
                        {validator: validateMobile, trigger: "blur"} ,
                        {validator: checkExistMobile, trigger: "blur"}],
                    qcountryMobile: [   {required: true, message: "请选择区号", trigger: "blur"}   ],
                    code: [   {required: true, message: "请输入验证码", trigger: "blur"}   ],
                    pimg: [   {required: true, message: "请上传近照", trigger: "blur"}   ],
                },


            }
        },
        methods: {
            dowmloadHandle(){
                window.open(this.download_applydoc,"_blank")
            },
            beforeUploadFile(file){
                const isLt2M = file.size / 1024 / 1024 < pimgSize;
                if (!isLt2M) {
                    this.$message.error('上传照片大小不能超过 '+pimgSize+' MB!');
                    return isLt2M;
                }
                this.loading = this.$loading({
                    lock: true,
                    text: "上传中，请稍等...",
                    spinner: "el-icon-loading",
                    background: "rgba(0, 0, 0, 0.5)",
                });
            },
            handleFileSuccess(res) {
                this.loading.close();
                if( res.status==1){
                    this.dataForm.pimg=res.obj;
                    this.imgdata={oldimgpath:this.dataForm.pimg};
                }else{
                    this.dataForm.pimg='';
                    this.$message.error( '上传失败' );
                }

            },

            selqcm(t){
                console.log(t)
                this.dataForm.countryMobile=t.name;
                this.dataForm.quhaoMobile=t.value;
            },
            emailXiala(){
                this.emailLi=[];
                this.emailLi.push(this.dataForm.email+"@qq.com");
                this.emailLi.push(this.dataForm.email+"@163.com");
                this.emailLi.push(this.dataForm.email+"@sina.com");
                this.emailLi.push(this.dataForm.email+"@sohu.com");
                this.emailLi.push(this.dataForm.email+"@yahoo.com");
                this.emailLi.push(this.dataForm.email+"@gmail.com");
                this.emailLi.push(this.dataForm.email+"@hotmail.com");
                this.showEmailXiala=true;
                if(this.dataForm.email.indexOf("@")>-1) this.showEmailXiala=false;
            },
            selemailHandle(t){
                this.showEmailXiala=false;
                this.dataForm.email=t;
            },
            submitForm() {
                this.dataForm.sessionid=this.sessionid;
                if(this.checked==false){
                    this.$message("请同意本平台协议");return;
                }

                this.$refs.dataForm.validate(valid => {

                    //表单验证失败
                    if (!valid) {
                        //提示语
                        this.$message("请按提示填写表单");
                        return false;
                    } else {
                        this.loading = this.$loading({
                            lock: true,
                            text: "注册中，请稍等...",
                            spinner: "el-icon-loading",
                            background: "rgba(0, 0, 0, 0.5)",
                        });

                        reg(this.dataForm).then((res) => {
                            this.loading.close();
                            if (res.data.status == 1) {
                                localStorage.uname=this.dataForm.uname;

                                this.$store.dispatch('saveFaceimg',res.data.obj.faceimg);
                                this.$store.dispatch('saveLogininfo',JSON.stringify(res.data.obj));


                                this.$message.success(res.data.msg);

                                this.$router.replace("/tip");

                            } else {

                                this.$message.error(res.data.msg)
                            }
                        }).catch(() => {
                            this.loading.close();
                            this.$message.info('请求失败，请检查网络');
                        });
                    }
                })
            },
            getImgCodeFunc(){
                getImgCode({sessionid:this.sessionid}).then((res) => {
                    if (res.data.status == 1) {
                        this.codeimg=res.data.obj;
                    } else {
                        this.codeimg='';
                        this.$message.error(res.data.msg)
                    }
                })
            }


        }, mounted() {
            this.windowWidth=getWindowWidth();


            if(this.$store.state.sessionid.trim().length==0){
                this.$store.dispatch('saveSessionid',getSessionid());
            }
            this.sessionid=this.$store.state.sessionid;

            this.getImgCodeFunc();
            this.qcountryMobileLi=qcountryMobileLi;
            this.dataForm.qcountryMobile=qcountryMobileLi[0].name+qcountryMobileLi[0].value;
            this.dataForm.countryMobile=qcountryMobileLi[0].name;
            this.dataForm.quhaoMobile=qcountryMobileLi[0].value;

            this.FILE_ACTION=process.env.VUE_APP_API_ROOT+'/common/upimg?type=pimg';
            this.download_applydoc=process.env.VUE_APP_API_ROOT+'/common/downfile?type=applydoc';

            this.pimgSize=pimgSize;


        }
    };
</script>

<style scoped>

    .login-wrap {
        position: relative;
        width: 100%;
        min-height: 100vh;
        background: url(../assets/img/reg_repeat_bg.png)  repeat-x #bee1f5;
        overflow-x: hidden;

    }
    .W_logo_wave  {
        height: 164px;
        background: url(../assets/img/bg_reg_wave.png) no-repeat center bottom;
        _background: none;
    }
    .W_reg_header {
        width: auto;
        margin: 0 auto;
        padding: 10px 0;
        text-align: center;
    }


    .emailxialac{position: absolute;z-index: 10;background: #fff;margin-left: 100px;padding: 0px 10px;box-shadow: 2px 2px 2px rgba(0,0,0,0.2)}
.xieyi{color: #0a8cd2;cursor: pointer;}


.kkweb{max-width: 500px;margin: 10px auto;}
.kkphone2{width:400px;margin: 0 auto;}
.kkphone{   width: 100%;}

 .login-btn {
        text-align: center;
    }

    /deep/ .el-input-group__append, .el-input-group__prepend{
        padding:0px 0px;
    }



    .kkphone /deep/   .el-input-group__prepend{padding: 0px 10px;}
    .kkphone   /deep/ .el-card__body, .el-main{padding: 0;}
</style>
